module.exports = __webpack_public_path__ + "static/media/秒杀.ca6d191c.png";